import type { AiRouter } from "replo-publisher/src/trpc/routers/ai";

import { getNamespacedQueryClient } from "../utils/trpc";
import { createTrpcRouterConfig } from "./config";

const {
  router: aiRouter,
  client: aiClient,
  utils: aiUtils,
  options: aiOptions,
} = createTrpcRouterConfig<AiRouter>({
  path: "ai",
  queryClient: getNamespacedQueryClient("ai"),
});

export { aiClient, aiRouter, aiUtils, aiOptions };
